import { showToast } from '@design-system';
import { getUser } from '@features/auth/auth.slice';
import { useCreateBtpCardDeliveryMutation } from '@services';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

export const useCarteBtpPageVM = () => {
    const [location, setLocation] = useState<string>('');
    const [checked, setChecked] = useState<boolean>(false);
    const [signature, setSignature] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const user = useSelector(getUser);
    const date = new Date().toLocaleDateString();

    const [createBtpCardDelivery, { isLoading, isSuccess, isError }] = useCreateBtpCardDeliveryMutation();

    const handleCreateBtpCardDelivery = () => {
        createBtpCardDelivery({ city: location, date });
    };

    const resetData = () => {
        setLocation('');
        setChecked(false);
        setSignature(false);
    };

    useEffect(() => {
        if (isSuccess) {
            showToast({
                message: 'Attestation envoyée avec succès',
                type: 'success'
            });

            resetData();
        }

        if (isError) {
            setErrorMessage("Une erreur est survenue lors de la création de l'attestation");
        }
    }, [isSuccess, isLoading, isError]);

    return {
        location,
        setLocation,
        user,
        date,
        checked,
        setChecked,
        signature,
        setSignature,
        isFilled: useMemo(() => checked && location.length > 2 && signature, [checked, location.length, signature]),
        errorMessage,
        handleCreateBtpCardDelivery
    };
};
